import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SprintService } from '../sprint.service';
import { TaskService } from '../task.service';
import { Task } from '../protogen/planning/service_pb';

@Component({
  selector: 'app-task-details',
  templateUrl: './task-details.component.html',
  styleUrls: ['./task-details.component.scss']
})
export class TaskDetailsComponent implements OnInit {
  dataLoaded: boolean = false;
  task: Task.AsObject = new Task().toObject();
  creationTime: string = '';
  sprintNamePromises: Map<string, Promise<string>> = new Map();

  constructor(
      private route: ActivatedRoute,
      private taskService: TaskService,
      private sprintService: SprintService) {
    this.fetchTask();
  }

  ngOnInit(): void { }

  getSprintName(sprintId: string): Promise<string> {
    if (this.sprintNamePromises.has(sprintId)) {
      const sprintNamePromise = this.sprintNamePromises.get(sprintId);
      if (sprintNamePromise instanceof Promise) {
        return sprintNamePromise;
      }
    }

    const sprintNamePromise: Promise<string> =
        this.sprintService.getSprintDetails(sprintId).then(
            response => response.sprint?.name || 'UNKNOWN SPRINT');
    this.sprintNamePromises.set(sprintId, sprintNamePromise);
    return sprintNamePromise;
  }

  private async fetchTask() {
    const taskId = this.route.snapshot.paramMap.get('taskId');
    if (taskId) {
      this.task = await this.taskService.getTask(taskId);
      this.dataLoaded = true;
      this.creationTime = new Date(parseInt(this.task.creationTimeMs, 10)).toISOString();
    }
  }
}
